import { useState } from 'react';
import { toast } from 'react-toastify';
import {
  TicketStatus,
  useTicketStatuses,
  UseTicketStatusesReturn,
} from 'src/pages/ServiceRequest/CustomHooks/useTicketStatuses';
import {
  useCustomStatusesAPI,
  UseCustomStatusesAPIReturn,
} from './useCustomStatusesAPI';

export interface UseStatusManagerOrchestratorReturn {
  statuses: TicketStatus[];
  loading: boolean;
  submitting: boolean;
  onSetLabel: (status: TicketStatus, label: string) => Promise<boolean>;
  onClearLabel: (status: TicketStatus) => Promise<boolean>;
}

const successToast = (message: string): void => {
  toast.success(message, { autoClose: 5000, position: 'top-center' });
};

export const useStatusManagerOrchestrator = (
  onApplied?: () => void
): UseStatusManagerOrchestratorReturn => {
    const tickets: UseTicketStatusesReturn = useTicketStatuses();
    const api: UseCustomStatusesAPIReturn = useCustomStatusesAPI();

    const [submitting, setSubmitting] = useState<boolean>(false);

    const onSetLabel = async (
      status: TicketStatus,
      label: string
    ): Promise<boolean> => {
      const trimmed: string = label.trim();

      if (!trimmed) {
        return false;
      }

      setSubmitting(true);
      const ok: boolean = await api.setLabel(status.id, trimmed);

      if (ok) {
        tickets.updateCustomLabel(status.id, trimmed);
        successToast(`"${status.name}" now displays as "${trimmed}".`);
        onApplied?.();
      }

      setSubmitting(false);
      return ok;
    };

    const onClearLabel = async (status: TicketStatus): Promise<boolean> => {
      setSubmitting(true);
      const ok: boolean = await api.clearLabel(status.id);

      if (ok) {
        tickets.updateCustomLabel(status.id, null);
        successToast(`"${status.name}" reset to its default label.`);
        onApplied?.();
      }

      setSubmitting(false);
      return ok;
    };

    return {
      statuses: tickets.ticketStatuses,
      loading: tickets.loading,
      submitting,
      onSetLabel,
      onClearLabel,
    };
  };
